import React, { useRef, useState } from 'react'
import { useAuth } from 'react-oidc-context'

export const DownloadButton = ({ url, onClick, children, className, defaultExtension = '', disabled = false }) => {
  const ref = useRef(null)
  const [downloadUrl, setDownloadUrl] = useState()
  const [name, setFileName] = useState()
  const auth = useAuth()

  const download = async e => {
    if (onClick) {
      onClick(e)
    }
    if (!url) {
      return
    }
    try {
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${auth.user?.access_token}`,
        },
      })

      if (!response.ok) {
        const errorText = await response.text()
        console.error('Download request failed:', response.status, errorText)
        return
      }

      const filename = response.headers.get('content-disposition')?.split('"')[1] ?? `download.${defaultExtension}`
      const requestUrl = URL.createObjectURL(new Blob([await response.blob()]))
      setDownloadUrl(requestUrl)
      setFileName(filename)
      ref.current?.click()
      URL.revokeObjectURL(requestUrl)
    } catch (error) {
      console.error('Download error:', error)
    }
  }

  return (
    <>
      <a
        href={downloadUrl}
        target="_blank"
        rel="noopener noreferrer"
        ref={ref}
        download={name}
        style={{ display: 'none' }}
      >
        Export
      </a>
      <button className={className} onClick={download} disabled={disabled}>
        {children}
      </button>
    </>
  )
}
